import AttachmentUrlConverter from './AttachmentUrlConverter';
import ThumbnailFarm from './ThumbnailFarm';

const ImageGridPattern = new RegExp(/\[##_ImageGrid\|([^|]*)\|([^|]*?)\|([^|]*?)_##\]/mgi);

class ImageGridConverter {
  static toHtml (content) {
    if (ImageGridPattern.test(content)) {
      return content.replace(ImageGridPattern, (match, keys, attributes, caption) => {
        const attributeList = attributes.split(',');
        const images = keys.split(',').map((key, index) => `<img src="${AttachmentUrlConverter.toUrl(key)}" ${attributeList[index]}/>`).join('');
        return `<figure data-ke-type="imageGrid">${images}<figcaption>${caption}</figcaption></figure>`;
      });
    }

    return content;
  }

  static toTistory (editor, e) {
    const { $ } = editor.dom;
    $('[data-ke-type="imageGrid"]', e.node).each((idx, elm) => {
      const $elm = $(elm);
      const imageUrls = [];
      const imageAttributes = [];
      $elm.find('img').each((idx, imageElm) => {
        imageUrls.push(AttachmentUrlConverter.toTistory(ThumbnailFarm.from(imageElm.src)));
        imageAttributes.push(Array.prototype.slice.call(imageElm.attributes)
          .filter(attr => attr.name !== 'src' && attr.name.indexOf('data-mce') !== 0)
          .map(attr => `${attr.name}="${attr.value}"`)
          .join(' ')
        );
      });
      const caption = $elm.find('figcaption').text().replace('|', '');

      elm.parentNode.replaceChild(editor.getDoc().createTextNode(`[##_ImageGrid|${imageUrls.join(',')}|${imageAttributes.join(',')}|${caption}_##]`), elm);
    });
  }
}

export default ImageGridConverter;
